"use client";

import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { ETAPES, type Etape } from "@/lib/diwline-data";
import { Sprout, HandHeart, Factory, Gem, Truck, Globe2 } from "lucide-react";

const ICONES: Record<Etape["icone"], typeof Sprout> = {
  sprout: Sprout,
  hand: HandHeart,
  factory: Factory,
  gem: Gem,
  truck: Truck,
  globe: Globe2,
};

export function Processus() {
  return (
    <section id="processus" className="relative bg-royal py-24 md:py-32" aria-label="Le cheminement royal de l'or liquide">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="✦"
          titre="Le Cheminement de l'Or"
          intro="D'agriculture royale en export mondial, chaque étape obéit à un protocole d'honneur — le voyage sacré de la graine sénégalaise jusqu'aux tables du monde."
        />

        <div className="relative">
          {/* Ligne dorée (desktop) */}
          <div className="absolute top-10 left-0 right-0 hidden h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent lg:block" aria-hidden />

          <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-6 lg:gap-4">
            {ETAPES.map((e, i) => {
              const Icone = ICONES[e.icone];
              return (
                <li key={e.numero}>
                  <Reveal delay={i * 0.1} className="h-full">
                    <div className="group relative flex h-full flex-col items-center rounded-sm border border-gold/15 bg-royal-brown/70 p-6 text-center transition-all duration-500 hover:border-gold/50 hover:bg-royal-panel">
                      <span className="absolute top-3 right-4 font-elegant text-2xl text-gold/25 transition-colors group-hover:text-gold/50">
                        {e.numero}
                      </span>
                      <span className="relative inline-flex h-16 w-16 items-center justify-center rounded-full border border-gold/45 bg-royal shadow-[0_0_28px_rgba(212,175,55,0.18)]">
                        <Icone className="h-7 w-7 text-gold" aria-hidden />
                        <span className="absolute inset-0 rounded-full border border-gold/20 animate-ping [animation-duration:3.5s]" aria-hidden />
                      </span>
                      <h3 className="mt-5 font-display text-lg font-semibold text-gold-light">
                        {e.titre}
                      </h3>
                      <p className="mt-3 text-[12.5px] leading-relaxed text-cream/70">{e.texte}</p>
                    </div>
                  </Reveal>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
